/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addOrUpdateTenderItems } from '../fn/tenders/add-or-update-tender-items';
import { AddOrUpdateTenderItems$Params } from '../fn/tenders/add-or-update-tender-items';
import { createTender } from '../fn/tenders/create-tender';
import { CreateTender$Params } from '../fn/tenders/create-tender';
import { deleteTenderItems } from '../fn/tenders/delete-tender-items';
import { DeleteTenderItems$Params } from '../fn/tenders/delete-tender-items';
import { getTender } from '../fn/tenders/get-tender';
import { GetTender$Params } from '../fn/tenders/get-tender';
import { getTenderItem } from '../fn/tenders/get-tender-item';
import { GetTenderItem$Params } from '../fn/tenders/get-tender-item';
import { getTenderItems } from '../fn/tenders/get-tender-items';
import { GetTenderItems$Params } from '../fn/tenders/get-tender-items';
import { listTenders } from '../fn/tenders/list-tenders';
import { ListTenders$Params } from '../fn/tenders/list-tenders';
import { PagedModelTenderItemResponseModel } from '../models/paged-model-tender-item-response-model';
import { PagedModelTenderResponseModel } from '../models/paged-model-tender-response-model';
import { patchTender } from '../fn/tenders/patch-tender';
import { PatchTender$Params } from '../fn/tenders/patch-tender';
import { removeTenderItem } from '../fn/tenders/remove-tender-item';
import { RemoveTenderItem$Params } from '../fn/tenders/remove-tender-item';
import { revokeTenderItemBid } from '../fn/tenders/revoke-tender-item-bid';
import { RevokeTenderItemBid$Params } from '../fn/tenders/revoke-tender-item-bid';
import { revokeTenderItemBids } from '../fn/tenders/revoke-tender-item-bids';
import { RevokeTenderItemBids$Params } from '../fn/tenders/revoke-tender-item-bids';
import { setTenderItemBid } from '../fn/tenders/set-tender-item-bid';
import { SetTenderItemBid$Params } from '../fn/tenders/set-tender-item-bid';
import { setTenderItemBid1 } from '../fn/tenders/set-tender-item-bid-1';
import { SetTenderItemBid1$Params } from '../fn/tenders/set-tender-item-bid-1';
import { TenderItemResponseModel } from '../models/tender-item-response-model';
import { TenderResponseModel } from '../models/tender-response-model';
import { updateTender } from '../fn/tenders/update-tender';
import { UpdateTender$Params } from '../fn/tenders/update-tender';
import { updateTenderItem } from '../fn/tenders/update-tender-item';
import { UpdateTenderItem$Params } from '../fn/tenders/update-tender-item';


/**
 * Tender and tender item management endpoints. All operations require EASYLOT_ADMIN or PRODUCT_ADMIN role. Tender creation and modification also require a valid site context.
 */
@Injectable({ providedIn: 'root' })
export class TendersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTender()` */
  static readonly GetTenderPath = '/tenders/{tenderId}';

  /**
   * Gets a tender.
   *
   * Returns the specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTender()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTender$Response(params: GetTender$Params, context?: HttpContext): Observable<StrictHttpResponse<TenderResponseModel>> {
    const obs = getTender(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets a tender.
   *
   * Returns the specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTender$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTender(params: GetTender$Params, context?: HttpContext): Observable<TenderResponseModel> {
    const resp = this.getTender$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TenderResponseModel>): TenderResponseModel => r.body)
    );
  }

  /** Path part for operation `updateTender()` */
  static readonly UpdateTenderPath = '/tenders/{tenderId}';

  /**
   * Fully replaces a tender (PUT).
   *
   * Replaces all fields of the specified tender with the provided values. All fields must be supplied. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTender()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTender$Response(params: UpdateTender$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateTender(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Fully replaces a tender (PUT).
   *
   * Replaces all fields of the specified tender with the provided values. All fields must be supplied. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTender$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTender(params: UpdateTender$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateTender$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchTender()` */
  static readonly PatchTenderPath = '/tenders/{tenderId}';

  /**
   * Partially updates a tender (PATCH).
   *
   * Updates only the provided fields of the specified tender; omitted fields are unchanged. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchTender()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchTender$Response(params: PatchTender$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = patchTender(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Partially updates a tender (PATCH).
   *
   * Updates only the provided fields of the specified tender; omitted fields are unchanged. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchTender$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchTender(params: PatchTender$Params, context?: HttpContext): Observable<void> {
    const resp = this.patchTender$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTenderItems()` */
  static readonly GetTenderItemsPath = '/tenders/{tenderId}/items';

  /**
   * Listing items of a tender.
   *
   * Returns the items of specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenderItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenderItems$Response(params: GetTenderItems$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelTenderItemResponseModel>> {
    const obs = getTenderItems(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing items of a tender.
   *
   * Returns the items of specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenderItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenderItems(params: GetTenderItems$Params, context?: HttpContext): Observable<PagedModelTenderItemResponseModel> {
    const resp = this.getTenderItems$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelTenderItemResponseModel>): PagedModelTenderItemResponseModel => r.body)
    );
  }

  /** Path part for operation `addOrUpdateTenderItems()` */
  static readonly AddOrUpdateTenderItemsPath = '/tenders/{tenderId}/items';

  /**
   * Adds/update items to a tender.
   *
   * Adds/updates items of specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOrUpdateTenderItems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOrUpdateTenderItems$Response(params: AddOrUpdateTenderItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = addOrUpdateTenderItems(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Adds/update items to a tender.
   *
   * Adds/updates items of specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addOrUpdateTenderItems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOrUpdateTenderItems(params: AddOrUpdateTenderItems$Params, context?: HttpContext): Observable<void> {
    const resp = this.addOrUpdateTenderItems$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTenderItems()` */
  static readonly DeleteTenderItemsPath = '/tenders/{tenderId}/items';

  /**
   * Removes items from a tender.
   *
   * Removes the specified items from specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTenderItems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteTenderItems$Response(params: DeleteTenderItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteTenderItems(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes items from a tender.
   *
   * Removes the specified items from specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTenderItems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteTenderItems(params: DeleteTenderItems$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteTenderItems$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTenderItem()` */
  static readonly GetTenderItemPath = '/tenders/{tenderId}/items/{itemId}';

  /**
   * Gets an item of a tender.
   *
   * Returns the specified item of specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenderItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenderItem$Response(params: GetTenderItem$Params, context?: HttpContext): Observable<StrictHttpResponse<TenderItemResponseModel>> {
    const obs = getTenderItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets an item of a tender.
   *
   * Returns the specified item of specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenderItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenderItem(params: GetTenderItem$Params, context?: HttpContext): Observable<TenderItemResponseModel> {
    const resp = this.getTenderItem$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TenderItemResponseModel>): TenderItemResponseModel => r.body)
    );
  }

  /** Path part for operation `updateTenderItem()` */
  static readonly UpdateTenderItemPath = '/tenders/{tenderId}/items/{itemId}';

  /**
   * Updates an item of a tender.
   *
   * Updates the specified item of specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTenderItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenderItem$Response(params: UpdateTenderItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateTenderItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates an item of a tender.
   *
   * Updates the specified item of specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTenderItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenderItem(params: UpdateTenderItem$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateTenderItem$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeTenderItem()` */
  static readonly RemoveTenderItemPath = '/tenders/{tenderId}/items/{itemId}';

  /**
   * Remove an item from a tender.
   *
   * Removes the specified item from specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeTenderItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeTenderItem$Response(params: RemoveTenderItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = removeTenderItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove an item from a tender.
   *
   * Removes the specified item from specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeTenderItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeTenderItem(params: RemoveTenderItem$Params, context?: HttpContext): Observable<void> {
    const resp = this.removeTenderItem$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setTenderItemBid()` */
  static readonly SetTenderItemBidPath = '/tenders/{tenderId}/items/{itemId}/price';

  /**
   * Sets a bid on a tender item.
   *
   * Sets the bid of the specified item of specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setTenderItemBid()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setTenderItemBid$Response(params: SetTenderItemBid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setTenderItemBid(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sets a bid on a tender item.
   *
   * Sets the bid of the specified item of specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setTenderItemBid$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setTenderItemBid(params: SetTenderItemBid$Params, context?: HttpContext): Observable<void> {
    const resp = this.setTenderItemBid$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeTenderItemBid()` */
  static readonly RevokeTenderItemBidPath = '/tenders/{tenderId}/items/{itemId}/price';

  /**
   * Revokes a bid on a tender item.
   *
   * Revokes the bid of the specified item of the specified tender. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeTenderItemBid()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeTenderItemBid$Response(params: RevokeTenderItemBid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = revokeTenderItemBid(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Revokes a bid on a tender item.
   *
   * Revokes the bid of the specified item of the specified tender. Requires EASYLOT_ADMIN or PRODUCT_ADMIN.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeTenderItemBid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeTenderItemBid(params: RevokeTenderItemBid$Params, context?: HttpContext): Observable<void> {
    const resp = this.revokeTenderItemBid$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setTenderItemBid1()` */
  static readonly SetTenderItemBid1Path = '/tenders/{tenderId}/items/prices';

  /**
   * Sets a bid on a tender item.
   *
   * Sets the bid of the specified item of specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setTenderItemBid1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setTenderItemBid1$Response(params: SetTenderItemBid1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setTenderItemBid1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sets a bid on a tender item.
   *
   * Sets the bid of the specified item of specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setTenderItemBid1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setTenderItemBid1(params: SetTenderItemBid1$Params, context?: HttpContext): Observable<void> {
    const resp = this.setTenderItemBid1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeTenderItemBids()` */
  static readonly RevokeTenderItemBidsPath = '/tenders/{tenderId}/items/prices';

  /**
   * Revokes bids on a tender item.
   *
   * Revokes the bids of the specified items of specified tender.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeTenderItemBids()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revokeTenderItemBids$Response(params: RevokeTenderItemBids$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = revokeTenderItemBids(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Revokes bids on a tender item.
   *
   * Revokes the bids of the specified items of specified tender.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeTenderItemBids$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revokeTenderItemBids(params: RevokeTenderItemBids$Params, context?: HttpContext): Observable<void> {
    const resp = this.revokeTenderItemBids$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listTenders()` */
  static readonly ListTendersPath = '/tenders';

  /**
   * Listing tenders.
   *
   * Lists available tenders. Only one of query parameters could be set but not both of them.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTenders()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenders$Response(params?: ListTenders$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelTenderResponseModel>> {
    const obs = listTenders(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Listing tenders.
   *
   * Lists available tenders. Only one of query parameters could be set but not both of them.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTenders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTenders(params?: ListTenders$Params, context?: HttpContext): Observable<PagedModelTenderResponseModel> {
    const resp = this.listTenders$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelTenderResponseModel>): PagedModelTenderResponseModel => r.body)
    );
  }

  /** Path part for operation `createTender()` */
  static readonly CreateTenderPath = '/tenders';

  /**
   * Create a new tender.
   *
   * Creates a new tender
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTender()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTender$Response(params: CreateTender$Params, context?: HttpContext): Observable<StrictHttpResponse<TenderResponseModel>> {
    const obs = createTender(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new tender.
   *
   * Creates a new tender
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTender$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTender(params: CreateTender$Params, context?: HttpContext): Observable<TenderResponseModel> {
    const resp = this.createTender$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TenderResponseModel>): TenderResponseModel => r.body)
    );
  }

}
